import { axiosPersonal } from '../plugins/axios';

const http = {
  get(endpoint) {
    return axiosPersonal.get(endpoint)
      .then((res) => res.data.data)
      .catch((error) => {
        throw error;
      });
  },

  create(endpoint, payload) {
    return axiosPersonal.post(endpoint, payload)
      .then((res) => res.data.data)
      .catch((error) => {
        throw error;
      });
  },

  update(endpoint, payload) {
    return axiosPersonal.put(endpoint, payload)
      .then((res) => res.data.data)
      .catch((error) => {
        throw error;
      });
  },
};

export default http;
